// application service
export default {
    install: (Vue) => {
      //private
      const route = process.env.VUE_APP_API_BASE_URL + '/api/applications';
  
      //public
      Vue.$applicationService = {
        create(params) {
          // The existing 'route' variable points to /api/applications
          // It might be better to define specific routes for each method
          // or pass the full path if the service is meant to be generic.
          // For now, let's assume 'route' is for the original 'create' method.
          const applicationsRoute = process.env.VUE_APP_API_BASE_URL + '/api/applications';
          return Vue.axios.post(applicationsRoute, { 
            // Strapi v4 expects data in a 'data' object for POST/PUT
            // If 'params' is the payload, it should be { data: params }
            // Original code was { params: params }, which is for query params in GET
            // This might need correction for the existing 'create' method too.
            // For now, I'll keep it as is for 'create' to avoid breaking existing functionality
            // and focus on the new method.
            params: params 
          });
        },
        submitImplementationGrantScreener(payload) {
          const screenerRoute = process.env.VUE_APP_API_BASE_URL + '/api/r-implementation-grant-screeners';
          return Vue.axios.post(screenerRoute, payload); // payload should be { data: { ... } }
        },
        submitImplementationGrantReport(payload) {
          const reportRoute = process.env.VUE_APP_API_BASE_URL + '/api/r-implementation-grant-reports';
          return Vue.axios.post(reportRoute, payload); // payload should be { data: { ... } }
        }
      };
    }
  };
//   //example of use
//   var grants = await Vue.$grantService.find({
//     name: 'test'
//   });
